import React from 'react'
import { type LicenseFulfillment } from '../license-lookup.types'
import { localeDate } from '../../common/js/date-utility'

type Props = {
    fulfillment: LicenseFulfillment
}

export default function FulfillmentItem({fulfillment}: Props) {
    const activationDateFormatted = localeDate(fulfillment.dateActivated);
    const expiration = fulfillment.expires || 'permanent';
  return (
    <tr>
        <td>{activationDateFormatted}</td>
        <td>{fulfillment.hostName}</td>
        <td>{fulfillment.hostId}</td>
        <td>{expiration}</td>
        <td>{fulfillment.count}</td>
    </tr>
  )
}